import script from "./ProjectCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCard.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=60cd8fc5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60cd8fc5"]])

export default __exports__